import {Injectable} from "@angular/core";
import {ExposeGeneratorFeatureState, exposeGeneratorSelectors} from "./store";
import {Store} from "@ngrx/store";
import {ExposeGeneratorActions} from "./store/action-types";
import {ExposeGeneratorInput} from "./expose-generator.model";
import {ExposeGeneratorApiFacade} from "./expose-generator-api.facade";
import {Observable} from "rxjs";

@Injectable({ providedIn: 'root' })
export class ExposeGeneratorDataFacade {
  exposees$ = this._store$.select(exposeGeneratorSelectors.exposees);
  exposeesLoading$ = this._store$.select(exposeGeneratorSelectors.exposeesLoading)
  constructor(
    private readonly _store$: Store<ExposeGeneratorFeatureState>,
    private readonly _exposeGeneratorApiFacade: ExposeGeneratorApiFacade,
  ) { }

  public createExposeGenerator(objectId: string, exposeGenerator: ExposeGeneratorInput): void {
    this._store$.dispatch(ExposeGeneratorActions.CreateExposeGenerator({ objectId, exposeGenerator }))
  }

  public loadExposees(objectId: string): void {
    this._store$.dispatch(ExposeGeneratorActions.LoadExposees({ objectId }))
  }

  public sendChatMessage(threadId: string, message: string): void {
    this._store$.dispatch(ExposeGeneratorActions.SendChatMessage({ threadId, message }));
  }

  public loadSessions(objectId: string): Observable<{ sessionName: string; openaiThreadId: string }[]> {
    return this._exposeGeneratorApiFacade.getChatSessions$(objectId);
  }

  public loadMessages(openaiThreadId: string): Observable<{ role: 'user' | 'assistant'; content: string }[]> {
    return this._exposeGeneratorApiFacade.getChatMessages$(openaiThreadId);
  }

  public createNewThread(objectId: string): Observable<{ sessionName: string; openaiThreadId: string }> {
    return this._exposeGeneratorApiFacade.createNewChatThread$(objectId);
  }
}
